import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet | Tømrermester Jacob"
        description="Den side, du leder efter, findes desværre ikke."
      />

      <section className="py-20 lg:py-32 bg-stone-50 min-h-[70vh] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <div className="w-16 h-16 rounded-2xl bg-red-100 text-[#ce0611] flex items-center justify-center mx-auto text-2xl font-bold">
            <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          </div>

          <span className="text-xs font-bold uppercase tracking-widest text-[#ce0611] bg-red-100/80 px-3 py-1 rounded-full">
            Fejlkode 404
          </span>

          <h1 className="text-3xl sm:text-4xl font-bold text-stone-900 tracking-tight">
            Siden blev ikke fundet
          </h1>

          <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
            Vi kunne desværre ikke finde den side, du ledte efter. Den kan være blevet flyttet eller slettet.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center px-7 py-3.5 rounded-full bg-[#ce0611] hover:bg-[#b0040e] text-white font-semibold text-sm shadow-sm transition-all"
            >
              <i className="fa-solid fa-house mr-2 text-xs" aria-hidden="true"></i>
              <span>Tilbage til forsiden</span>
            </Link>

            <Link
              to="/vi-tilbyder"
              className="inline-flex items-center px-6 py-3.5 rounded-full bg-white hover:bg-stone-100 text-stone-800 font-semibold text-sm border border-stone-300 shadow-xs transition-colors"
            >
              <i className="fa-solid fa-layer-group mr-2 text-[#ce0611]" aria-hidden="true"></i>
              <span>Se vores ydelser</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
